import React from "react";
import { Flex, Text, useToken } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import useRouterHelper from "@/features/ui/hooks/use-router-helper";

interface Props {
  // 만료 종류에 따라 좌측 문구만 달라진다 (무료체험 종료 / 멤버십 종료)
  status: "TRIAL_EXPIRED" | "SUBSCRIPTION_EXPIRED";
}

/**
 * 만료 바이어용 사용량 카드 대체 — 만료 상태의 usage 응답은 0·미지원으로만 채워져
 * 진행바와 초기화 안내가 오히려 오해를 준다. 상태 한 줄과 플랜 CTA만 남긴다.
 *
 * 사용량 카드와 같은 슬롯에 들어가므로 라운드·hairline·폭 규칙을 그대로 맞춘다.
 * 순수 표시 컴포넌트로 유지할 것 — 여기서 쿼리를 부르면 만료 사용자에게
 * 사용량 요청·Suspense 대기가 되살아나 대체의 목적이 사라진다.
 */
function PathPickUsageExpiredCard({ status }: Props) {
  const { t } = useI18nHelper();
  const [hairlineDefault] = useToken("shadows", ["hairlineDefault"]);
  // 라우트가 /:locale? 아래라 raw useNavigate는 로케일 프리픽스를 잃는다.
  const { navigate } = useRouterHelper();

  return (
    <Flex
      alignItems={"center"}
      justifyContent={"space-between"}
      gap={"12px"}
      padding={"8px 12px"}
      borderRadius={"8px"}
      background={"#FFFFFF"}
      boxShadow={hairlineDefault}
      /* 사용량 카드와 동일 규칙 — 좁은 폭에서 부모 밖으로 넘치지 않게 축소하고,
         모바일(base)에서는 한 줄을 꽉 채워 옆 버튼이 다음 줄로 내려가게 한다. */
      width={{ base: "100%", md: "auto" }}
      maxWidth={"100%"}
      minWidth={0}
      flexShrink={1}
    >
      <Text textStyle={"body-md-bold"} color={"#1D1D1B"}>
        {t(
          status === "TRIAL_EXPIRED"
            ? "path_pick:usage_card.expired_trial_title"
            : "path_pick:usage_card.expired_subscription_title"
        )}
      </Text>
      <AppButton
        variant={"white"}
        height={"32px"}
        onClick={() => navigate("/pathpick/membership")}
        chakraProps={{ padding: "4px 12px", flexShrink: 0 }}
      >
        <Text textStyle={"body-sm-bold"}>
          {t("path_pick:membership_lock.cta_plans")}
        </Text>
      </AppButton>
    </Flex>
  );
}

export default PathPickUsageExpiredCard;
